(function($) {
	'use strict';

	/**
	 * Extract unique standard IDs from data
	 * 
	 * This function processes the Combined data structure to extract all
	 * unique standard IDs from the related control items. It validates
	 * the data structure and returns a sorted array of standard IDs.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @param {string} year - The year to process (defaults to "2025")
	 * @returns {Array} Sorted array of unique standard IDs
	 */
	function extractUniqueStandardIDs(data, year = "2025") {
		if (!data.Combined) {
			console.error("Data structure is not as expected.");
			return [];
		}
		const uniqueStandardIDs = new Set();
		data.Combined.flatMap(item => item.relatedCSItems || [])
			.forEach(item => {
				if (item.standardid && item.standardid.S) {
					uniqueStandardIDs.add(item.standardid.S);
				}
			});
		return Array.from(uniqueStandardIDs).sort(); // Sorting standard IDs alphanumerically
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { extractUniqueStandardIDs };
	} else if (typeof window !== 'undefined') {
		window.extractUniqueStandardIDs = extractUniqueStandardIDs;
	}

})(jQuery);
